import { t } from 'i18next'

import translationKeys from '@translationKeys'

import { ShortlistProfilePriority } from '@modules/shortlist/types'

import SelectPriority from '../SelectPriority'
import { CellInfo } from '../types'

export const PriorityCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { onChangePriority, priorityOptions },
  } = info
  return (
    <SelectPriority
      key={profileData.priority}
      label={t(translationKeys.CUSTOM_LIST_TABLE_HEADER_PRIORITY)}
      priority={profileData.priority ?? ShortlistProfilePriority.NOT_SET}
      priorityOptions={priorityOptions}
      onSelect={(selectedPriority: ShortlistProfilePriority) =>
        onChangePriority(profileData.profileId, selectedPriority, profileData.profileType)
      }
    />
  )
}
